var _defs, _polygon, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.5 11.5 15.5 12.5 12.5 12.5 12.5 15.5 11.5 15.5 11.5 12.5 8.5 12.5 8.5 11.5 11.5 11.5 11.5 8.5 12.5 8.5 12.5 11.5 15.5 11.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.01,20.48c-2.88,0-5.54-1.44-7.12-3.86l1.26-.82c1.29,1.99,3.49,3.18,5.86,3.18,3.85,0,6.98-3.13,6.98-6.98s-3.13-6.98-6.98-6.98c-2.37,0-4.56,1.19-5.86,3.18l-1.26-.82c1.57-2.42,4.23-3.86,7.12-3.86,4.68,0,8.48,3.81,8.48,8.48s-3.81,8.48-8.48,8.48Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpIcon);
export default __webpack_public_path__ + "static/media/Sign-Up-Icon.5cd31b767a9110a7be07ce34db08425b.svg";
export { ForwardRef as ReactComponent };